import { render } from "./PolicyBpmSummary.vue?vue&type=template&id=40c6e68a"
import script from "./PolicyBpmSummary.vue?vue&type=script&lang=js"
export * from "./PolicyBpmSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__